import NextLink from "next/link";
import React, { useContext } from "react";

import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { colors, font } from "utils/styles";
import { NavContext } from "contexts/";
import switchMegaNav from "./switchMegaNav";
import { Icon } from "@components/Icons";

function DesktopNavigation() {
	const { userDropdownOpen } = useContext(NavContext);
	return (
		<Navbar className={`align-items-end flex-column ${userDropdownOpen ? "z-index-neg-1" : ""}  `} variant="light">
			<Nav className=" justify-content-between">
				<NavLink name="Career" text="Career & Learning" />
				<NavLink name="Resources" text="Leadership Library" />
				<NavLink name="Community" text="Membership & Community" />
				<NavLink text="For Organizations" link="/aapl-solutions" />
				<NavLink text="Store" name="Store" iconPosition="10%" />
				<NavLink name="About" text="About AAPL" />
			</Nav>
		</Navbar>
	);
}

const NavLink = ({ text, name, iconPosition, link }) => {
	const { setMegaNavName, megaNavName } = useContext(NavContext);
	const isSelected = name && megaNavName === name;

	return (
		<div className="relative">
			<li
				onMouseDown={(e) => {
					//prevents the useClickOutside hook from seeing this event
					e.nativeEvent.stopImmediatePropagation();

					name === megaNavName ? setMegaNavName("") : setMegaNavName(name);
				}}
				// onMouseEnter={() => setMegaNavName(name)}
				className={`nav-item ms-3 ms-xl-4 ms-xxl-5`}
			>
				{link && (
					<NextLink href={link}>
						<span className="nav-links ">{text}</span>
					</NextLink>
				)}
				{!link && <span className="nav-links ">{text}</span>}

				<Icon
					className="myShow"
					icon="triangle"
					style={{
						margin: "0",
						position: "absolute",
						top: "1.6em",
						left: iconPosition ? iconPosition : "40%",
						display: isSelected ? "block" : "none",
					}}
				/>
			</li>

			{isSelected && <div className={""}>{switchMegaNav(megaNavName)}</div>}

			<style jsx="true">{`
				.linkContainer {
					display: flex;
					justify-content: end;
					padding-right: 0;
				}
				.nav-item {
					display: flex;
					white-space: nowrap;

					cursor: pointer;
					position: relative;
				}
				.nav-item:hover {
					text-decoration: underline;
					color: ${colors["green"]};
				}
				.nav-links {
					display: flex;
					width: 100%;
					color: ${isSelected ? colors.lightBlue : colors.darkBlue} !important;
					font-weight: bold !important;
					font-family: ${font.default};
					line-height: 28px;
					font-size: 16px;
					white-space: nowrap;
				}

				@media screen and (max-width: 1200px) {
					.nav-links {
						line-height: 28px;
						font-size: 14px;
					}
				}
			`}</style>
		</div>
	);
};

export default DesktopNavigation;
